module.exports = __webpack_public_path__ + "static/media/main.7c732fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/main.jpg
// module id = 80
// module chunks = 0